import { render } from "./ProductSearchPage.vue?vue&type=template&id=53302454"
import script from "./ProductSearchPage.vue?vue&type=script&lang=js"
export * from "./ProductSearchPage.vue?vue&type=script&lang=js"

import "./ProductSearchPage.vue?vue&type=style&index=0&id=53302454&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__